import TimedMessageRequest from './request/TimedMessageRequest';
import {IStation} from '../../../dto/Station.dto';
import {iTimedMsgTimesItem} from './request/times/TimedMsgRequestTimesCard';
import {iTimedMessageMessageItem} from './request/contents/TimedMsgRequestContentMessageCard';
import {ITimedMessageDayType} from '../../../dto/timed-message/TimedMessageRequest.dto';

const defaultMessages: iTimedMessageMessageItem[] = [
  {
    id: Date.now(),
    type: 'message',
    message: '',
    artist: '',
    title: '',
    label: 'Message',
  },
];

const defaultState = {
  defaultStep: 0,
  defaultStations: [] as IStation[],
  defaultMessages,
  defaultDayType: 'no-end' as ITimedMessageDayType,
  defaultDateRanges: [
    {
      id: Date.now(),
      start_date: null,
      end_date: null,
    },
  ],
  defaultTimeItems: [
    {
      id: Date.now(),
      selectedDays: [],
      timeRanges: [],
    },
  ] as iTimedMsgTimesItem[],
};

const TimedMessageCreate = ({
  onClose,
  restoreId,
}: {
  onClose: () => void;
  restoreId?: number;
}) => {
  return (
    <TimedMessageRequest
      onClose={onClose}
      {...defaultState}
      restoreId={restoreId}
    />
  );
};

export default TimedMessageCreate;
